export const commonModels = {
  commonStatus: [
    {
      label: '启用',
      value: 1,
      color: 'green',
      status: 'success',
    },
    {
      label: '禁用',
      value: 0,
      color: 'red',
      status: 'disabled',
    },
  ],
  commonBooleanStatus: [
    {
      label: '是',
      value: 1,
    },
    {
      label: '否',
      value: 0,
    },
  ],
  timezonesArr: [
    { label: '(GMT -12:00) Eniwetok, Kwajalein', value: 'GMT-12:00' },
    { label: '(GMT -11:00) Midway Island, Samoa', value: 'GMT-11:00' },
    { label: '(GMT -10:00) Hawaii', value: 'GMT-10:00' },
    { label: '(GMT -9:00) Alaska', value: 'GMT-09:00' },
    { label: '(GMT -8:00) Pacific Time', value: 'GMT-08:00' },
    { label: '(GMT -7:00) Mountain Time', value: 'GMT-07:00' },
    { label: '(GMT -6:00) Central Time', value: 'GMT-06:00' },
    { label: '(GMT -5:00) Eastern Time', value: 'GMT-05:00' },
    { label: '(GMT -4:00) Atlantic Time', value: 'GMT-04:00' },
    { label: '(GMT -3:00) Brazil, Buenos Aires', value: 'GMT-03:00' },
    { label: '(GMT -2:00) Mid-Atlantic', value: 'GMT-02:00' },
    { label: '(GMT -1:00) Azores', value: 'GMT-01:00' },
    { label: '(GMT) Western Europe Time', value: 'GMT+00:00' },
    { label: '(GMT +1:00) Brussels, Madrid, Paris', value: 'GMT+01:00' },
    { label: '(GMT +2:00) Bratislava, South Africa', value: 'GMT+02:00' },
    { label: '(GMT +3:00) Baghdad, Riyadh', value: 'GMT+03:00' },
    { label: '(GMT +4:00) Abu Dhabi, Muscat', value: 'GMT+04:00' },
    { label: '(GMT +5:00) Islamabad, Karachi', value: 'GMT+05:00' },
    { label: '(GMT +6:00) Almaty, Dhaka', value: 'GMT+06:00' },
    { label: '(GMT +7:00) Bangkok, Hanoi', value: 'GMT+07:00' },
    { label: '(GMT +8:00) Beijing, Singapore', value: 'GMT+08:00' },
    { label: '(GMT +9:00) Tokyo, Seoul, Osaka', value: 'GMT+09:00' },
    { label: '(GMT +10:00) Eastern Australia, Guam', value: 'GMT+10:00' },
    { label: '(GMT +11:00) Solomon Islands', value: 'GMT+11:00' },
    { label: '(GMT +12:00) Wellington, Fiji', value: 'GMT+12:00' },
  ],
  dataDimensions: [
    { label: '日', value: 0 },
    { label: '小时', value: 1 },
  ],
  roleKeys: {
    OPTIMIZER_SERVICE: 'optimizer',
    BUSINESS_MANAGER: 'upstream_business',
  },
  productStatus: [
    {
      label: '停用',
      value: 0,
      tag: 'disabled'
    },
    {
      label: '启用',
      value: 1,
      tag: 'success'
    },
    // {
    //   label: '审核中',
    //   value: 2,
    //   tag: 'info'
    // }
  ],
  productType: [
    {
      label: 'iOS',
      value: 1,
    },
    {
      label: 'Android',
      value: 2,
    },
    {
      label: 'Web',
      value: 3,
    },
    { label: "其他", value: 4 },

  ],
  deviceType: [
    { label: 'PC', value: 'PC' },
    { label: 'Mobile', value: 'Mobile' }
  ],
  conversionEventOptions: [
    { label: "App_Install", value: "App_Install" },
    { label: "Lead_Double_Opt_In", value: "Lead_Double_Opt_In" },
    { label: "Lead_Single_Opt_In", value: "Lead_Single_Opt_In" },
    { label: "Multiple_Conversions_Types", value: "Multiple_Conversions_Types" },
    { label: "Purchase_Carrier_Billing", value: "Purchase_Carrier_Billing" },
    {
      label: "Purchase_COD_(Cash_On_Delivery)",
      value: "Purchase_COD_(Cash_On_Delivery)",
    },
    { label: "Purchase_Card", value: "Purchase_Card" },
    {
      label: "Subscription_Carrier_Billing",
      value: "Subscription_Carrier_Billing",
    },
    { label: "Subscription_Credit_Card", value: "Subscription_Credit_Card" },
    { label: "Website_Interaction", value: "Website_Interaction" },
  ],
  conversionCountOptions: [
    { label: "一次转化", value: "one" },
    { label: "每次转化", value: "every" },
  ],
  attributionWindowOptions: [
    { label: "12 hours", value: "12h" },
    { label: "24 hours", value: "24h" },
    { label: "2 days", value: "2d" },
    { label: "3 days", value: "3d" },
    { label: "7 days", value: "7d" },
    { label: "30 days", value: "30d" },
    { label: "90 days", value: "90d" },
    { label: "180 days", value: "180d" },
  ],
  advBusinessTypes: [
    { label: '充值', value: 1, color: 'green', status: 'success' },
    { label: '消耗', value: 2, color: 'blue', status: 'default' },
    { label: '退款', value: 3, color: 'orange', status: 'warning' },
    { label: '冻结', value: 4, color: 'red', status: 'danger' },
    { label: '解冻', value: 5, color: 'cyan', status: 'info' }
  ],
  transactionTypeOptions: [
    // { label: "全部类型", value: 0 },
    { label: '充值', value: 1, color: 'info' },
    { label: '消耗', value: 2, color: 'default' },
    { label: '退款', value: 3, color: 'warning' },
  ],
  publisherBusinessTypes: [
    { label: '流量消耗', value: 1 },
  ],
  campaignStatus: [
    { label: '投放中', value: 1, status: 'success', },
    { label: '已暂停', value: 2, status: 'disabled', },
  ],
  campaignTarget: [
    { value: 2, label: '应用推广', des: '提升用户的下载、安装、激活等行为' },
    { value: 3, label: '销售线索', des: '为您的生意销售收集用户线索' },
  ],
  adGroupStatus: [
    { label: '投放中', value: 1, status: 'success' },
    { label: '已暂停', value: 2, status: 'disabled' },
  ],
  adStatus: [
    { label: '投放中', value: 1, status: 'success' },
    { label: '已暂停', value: 2, status: 'disabled' },
  ],
  adType: [
    { label: 'Banner', value: 1 },
    { label: 'Video', value: 2 },
    { label: 'Native', value: 3 },
  ],
  budgetType: [
    { label: '不限', value: 1 },
    { label: '总预算', value: 2 },
    { label: '日预算', value: 3 },
  ],
  adGroupBudgetType: [
    { label: '不限', value: 1 },
    { label: '日预算', value: 3 },
  ],
  dimensions: [
    { width: 300, height: 100 },
    { width: 300, height: 250 },
    { width: 320, height: 480 },
    { width: 728, height: 90 },
    { width: 900, height: 250 },
  ],
  nativeDimensions: [{ width: 300, height: 250 }],
  videoScale: [
    { width: 16, height: 9 },
    { width: 9, height: 16 },
    { width: 1, height: 1 },
    { width: 2, height: 3 },
  ],
  bidType: [
    { value: 6, label: 'oCPM' },
    // { value: 7, label: 'oCPC' },
    { value: 1, label: 'CPM' },
    { value: 2, label: 'CPC' },
  ],
  // 操作系统
  osPlatform: [
    { value: '', label: '不限' },
    { value: 'Android', label: 'Android' },
    { value: 'iOS', label: 'iOS' },
  ],
  optimizeGoal: [
    { value: 1, label: '注册' },
    { value: 2, label: '激活' },
    { value: 3, label: '付费' },
  ],
  deliveryMode: [
    { value: 1, label: '加速投放' },
    { value: 2, label: '匀速投放' },
  ],
  mediaType: [
    { value: 1, label: '自动选择流量来源' },
    { value: 2, label: '手动选择流量来源' },
  ],
  osVersionList: {
    'Android': [
      ...Array(7)
        .fill('')
        .map((_, index) => {
          return { value: `${index + 8}.x`, label: `${index + 8}.x` }
        })
        .reverse(),
    ],
    'iOS': [
      ...Array(7)
        .fill('')
        .map((_, index) => {
          return {
            value: `${index + 11}.x`,
            label: `${index + 11}.x`,
          }
        })
        .reverse(),
    ],
  },
  mediaStatus: [
    { label: '启用', value: 1 },
    { label: '禁用', value: 2 },
  ],
  rtbVersion: [
    { label: '2.4', value: '2.4' },
    { label: '2.5', value: '2.5' },
    { label: '2.6', value: '2.6' },
  ],
  paymentTerm: [
    { label: '按月', value: 0 },
    { label: '按季', value: 1 },
    { label: '按年', value: 2 },
  ],
  paymentType: [
    { label: '预付', value: 0 },
    { label: '后付', value: 1 },
  ],
  pricingMethod: [
    { label: 'CPM', value: 0 },
    { label: 'CPC', value: 1 },
    // { label: 'CPI', value: 2 },
  ],
  userData: [
    { label: 'pubID Requied', value: 'pubID' },
    { label: 'UserID Requied', value: 'UserID' },
    { label: 'IFA Requied', value: 'IFA' },
    { label: 'Carrier Requied', value: 'Carrier' },
  ],
  trafficType: [
    { label: 'desktop', value: 2 },
    { label: 'smartTV', value: 3 },
    { label: 'mobile', value: 4 },
    { label: 'tablet', value: 5 },
    { label: 'unknown', value: 6 },
  ],
  osType: [
    { label: 'Windows', value: 'Windows' },
    { label: 'Android', value: 'Android' },
    { label: 'iOS', value: 'iOS' },
  ],
  networkType: [
    { label: 'WiFi', value: 2 },
    { label: '2G', value: 4 },
    { label: '3G', value: 5 },
    { label: '4G', value: 6 },
    { label: '5G', value: 7 },
  ],
  assetType: [
    {
      label: '图片',
      value: 1,
      format: ['jpg', 'jpeg', 'png', 'webp', 'gif'],
    },
    { label: '视频', value: 2, format: ['mp4'], size: 100 },
    {
      label: '图文',
      value: 3,
      format: ['jpg', 'jpeg', 'png', 'webp', 'gif'],
    },
  ],
  adxAdType: [
    { label: 'Banner', value: 'Banner' },
    { label: 'Video', value: 'Video' },
    { label: 'Native', value: 'Native' },
  ],
  adPlacement: [
    { label: '通投', value: 0 },
    { label: '联盟流量', value: 1 },
    { label: 'Telegram', value: 2 },
  ],
  timeWindowType: [
    { label: '每天', value: 1 },
    { label: '每周', value: 2 },
    { label: '投放周期内', value: 3 },
  ],
  // 联系方式类型
  contactTypeOptions: [
    { label: "WhatsApp", value: "whatsapp" },
    { label: "Wechat", value: "wechat" },
    { label: "Telegram", value: "telegram" },
    { label: "LINE", value: "line" },
  ],
  // 公司属性
  companyTypeOptions: [
    { label: "advertiser", value: "advertiser" }
  ],
  // 货币选项(ISO 4217)
  currencyOptions: [
    { label: "USD", value: "usd" }
  ],
  approvalStatus: [
    { label: '待审核', value: 0, status: 'default' },
    { label: '审核通过', value: 1, status: 'success' },
    { label: '驳回', value: 2, status: 'error' },
  ],
  resourceTypes: [{ label: 'app', value: 'app' },
  { label: 'site', value: 'site' },],
  statusOptions: [
    { label: "运行中", value: 1, status: "success" },
    { label: "停止", value: 2, status: "default" },
    { label: "封禁", value: 3, status: "error" },
  ],
  sspAppTypeOptions: [
    { label: "网站", value: 'web' },
    { label: "App", value: 'app' },
    { label: "Telegram", value: 'telegram' },
  ],

  positionOptions: [
    "Unknown",
    "Above the fold",
    "Below the fold",
    "Header",
    "Footer",
    "Sidebar",
    "Fullscreen",
  ],

  bannerSizeOptions: ["300x100", "300x250", "728x90", "900x250", "320x480"],

  videoPlacingOptions: [
    "In-Stream",
    "In-Banner",
    "In-Article",
    "In-Feed",
    "Interstitial/Slider/Floating",
  ],

  playbackOptions: [
    "Initiates on Page Load with Sound On",
    "Initiates on Page Load with Sound Off by Default",
    "Initiates on Click with Sound On",
    "Initiates on Mouse-Over with Sound On",
    "Initiates on Entering Viewport with Sound On",
    "Initiates on Entering Viewport with Sound Off by Default",
  ],

  frequencyOptions: [
    { label: "1小时", value: 3600 },
    { label: "6小时", value: 21600 },
    { label: "12小时", value: 43200 },
    { label: "24小时", value: 86400 },
    { label: "7天", value: 604800 },
    { label: "30天", value: 2592000 },
  ],

  blockAdTypeOptions: [
    { label: "XHTML Text Ad (usually mobile)", value: "XHTML Text Ad (usually mobile)" },
    { label: "XHTML Banner Ad.(usually mobile)", value: "XHTML Banner Ad.(usually mobile)" },
    { label: "JavaScript Ad; must be valid XHTML", value: "JavaScript Ad; must be valid XHTML" },
    { label: "iframe", value: "iframe" },
  ],

  blockedAttributesOptions: [
    { label: "Audio Ad (Auto-Play)", value: "Audio Ad (Auto-Play)" },
    { label: "Audio Ad (User Initiated)", value: "Audio Ad (User Initiated)" },
    { label: "Expandable(Automatic)", value: "Expandable(Automatic)" },
    { label: "Expandable (User Initiated -Click)", value: "Expandable (User Initiated -Click)" },
    { label: "Expandable (User initiated - Rollover)", value: "Expandable (User initiated - Rollover)" },
    { label: "In-Banner Video Ad (Auto-Play)", value: "In-Banner Video Ad (Auto-Play)" },
    { label: "In-Banner Video Ad (User Initiated)", value: "In-Banner Video Ad (User Initiated)" },
    { label: "Pop (e.g., Over, Under, or Upon Exit)", value: "Pop (e.g., Over, Under, or Upon Exit)" },
    { label: "Provocative or Suggestive lmagery", value: "Provocative or Suggestive lmagery" },
    {
      label: "Shaky, Flashing, Flickering, Extreme Animation, Smileys",
      value: "Shaky, Flashing, Flickering, Extreme Animation, Smileys"
    },
    { label: "Surveys", value: "Surveys" },
    { label: "Text Only", value: "Text Only" },
    { label: "User Interactive (e.g., Embedded Games)", value: "User Interactive (e.g., Embedded Games)" },
    { label: "Windows Dialog or Alert Style", value: "Windows Dialog or Alert Style" },
    { label: "Has Audio On/Off Button", value: "Has Audio On/Off Button" },
    {
      label: "Ad Provides Skip Button (e.g. VPAID-rendered skip button on pre-roll video)",
      value: "Ad Provides Skip Button (e.g. VPAID-rendered skip button on pre-roll video)"
    },
    { label: "Adobe Flash", value: "Adobe Flash" },
  ],

  allowMediaTypes: [
    { label: "MP4", value: "MP4" },
    { label: "MOV", value: "MOV" },
    { label: "AVI", value: "AVI" },
    { label: "MKV", value: "MKV" },
    { label: "WMV", value: "WMV" },
    { label: "WebM", value: "WebM" },
    { label: "FLV", value: "FLV" },
  ],

  adEnvironmentOptions: [
    { label: "Content-centric context", value: "Content-centric context" },
    { label: "Social-centric context", value: "Social-centric context" },
    { label: "Product context", value: "Product context" },
  ],

  advancedSettingsOptions: [
    { label: "General or mixed content", value: "General or mixed content" },
    { label: "Primarily article content", value: "Primarily article content" },
    { label: "Primarily video content", value: "Primarily video content" },
    { label: "Primarily audio content", value: "Primarily audio content" },
    { label: "Primarily image content", value: "Primarily image content" },
    { label: "User-generated content", value: "User-generated content" },
    { label: "General social content", value: "General social content" },
    { label: "Primarily email content", value: "Primarily email content" },
    { label: "Primarily chat/lM content", value: "Primarily chat/lM content" },
    { label: "Content focused on selling products", value: "Content focused on selling products" },
    { label: "Application store/marketplace", value: "Application store/marketplace" },
    { label: "Product reviews site primarily", value: "Product reviews site primarily" },
  ],

  adUnitOptions: [
    { label: "In the feed of content", value: "In the feed of content" },
    { label: "In the atomic unit of the content", value: "In the atomic unit of the content" },
    { label: "Outside the core content", value: "Outside the core content" },
    { label: "Recommendation widget", value: "Recommendation widget" },
  ],

  paymentTypeOptions: [
    { label: "预付", value: 1 },
    { label: "后付", value: 2 },
  ],

  billingCycleOptions: [
    { label: "半月结", value: 1 },
    { label: "月结", value: 2 },
    { label: "季度结", value: 3 },
  ],
}
